import styled from 'react-emotion';
import { themeGet, space } from 'styled-system';

export const H1 = styled('h1')`
  color: ${themeGet('colors.blueDarker')};
  font-weight: 700;
  font-size: 1.5rem;
  line-height: 1.25;
  margin: 0;
  padding: 0;
`;

export const H2 = styled('h2')`
  color: ${themeGet('colors.blueDarker')};
  font-weight: 500;
  fonz-size: 1.25rem;
  line-height: 1.25;
  margin: 0;
  padding: 0;
`;

export const H3 = styled('h3')`
  color: ${themeGet('colors.blueDarker')};
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.5;
  margin: 0;
  padding: 0;
`;

export const H4 = styled('h4')`
  color: ${themeGet('colors.blueDarker')};
  font-weight: 700;
  font-size: 0.875rem;
  line-height: 1.5;
  margin: 0;
  padding: 0;
`;

export const H5 = styled('h5')`
  color: ${themeGet('colors.blueDarker')};
  font-weight: 700;
  font-size: 0.75rem;
  line-height: 1.4;
  margin: 0;
  padding: 0;
`;

export const H6 = styled('h6')`
  color: ${themeGet('colors.blueDarker')};
  font-weight: 600;
  text-transform: uppercase;
  font-size: 0.675 rem;
  line-height: 1.5;
  margin: 0;
  padding: 0;
`;

export const P = styled('p')`
  color: ${themeGet('colors.black')};
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.4;
  margin: 0;
  padding: 0;
`;

export const Span = styled('span')`
  color: ${themeGet('colors.black')};
  font-weight: 400;
`;

export const FlexRow = styled('div')`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`;

export const FlexCol = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
`;

export const FlexRowCenter = styled(FlexRow)`
  justify-content: center;
  align-items: center;
`;

export const FlexRowBetween = styled(FlexRow)`
  justify-content: space-between;
`;

export const FlexColCenter = styled(FlexCol)`
  justify-content: center;
  align-items: center;
`;

export const Heading = styled('h3')`
  ${space};
  font-weight: 400;
  font-size: {
    props=>props.fontsize?props.fontsize: 20;
  }
  color: ${themeGet('colors.blueDarker')};
`;

export const Text = styled('span')`
  font-weight: 300;
  color: ${props =>
    props.color ? themeGet(`colors.${props.color}`) : themeGet('colors.black')};
`;

export const Checkbox = styled('input')`
  min-width: 24px;
  min-height: 24px;
  margin: 0 ${themeGet('space.2')}px;
  appearance: none;
  outline: none;
  box-shadow: 0 2px 6px rgba(184, 194, 204, 0.25);
  border: 1px solid ${themeGet('colors.greyLight')};
  border-radius: 50%;
  cursor: pointer;

  &:checked {
    border-color: transparent;
    background-color: ${themeGet('colors.indigoLight')};
    background-image: url("data:image/svg+xml;utf8,<svg viewBox='0 0 10 9' xmlns='http://www.w3.org/2000/svg'><path d='M1 4.88l2.378 2.435L9.046 1.6' stroke-width='1.6' stroke='%23FFF' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'/></svg>");
    background-position: center center;
    background-size: 80%;
    background-repeat: no-repeat;
  }
`;



// WEBPACK FOOTER //
// ./src/components/misc.js